import { type BaseOptionsType } from '@repo/advanced-filters';

export const visibleConditionsFilter = (options: any[], selectedActivities: any[]) => options.filter(
  (option: any) => selectedActivities.some(
    (activity) => activity.activityId === parseInt(option.value, 10),
  ),
);

export const TRIGGERED_ACTIVITY_CONFIG: BaseOptionsType = {
  value: 'triggered_activity',
  label: 'Triggered Activity',
  schemaName: 'activity_id',
  dataType: 'default',
  hasSubCondition: true,
  hasDateFilter: true,
  conditionKeyPrefix: 'triggered_activity',
  entityType: 'lead_activity',
  disabled: false,
};

export const getParsedTriggerActivityConfig = (selectedActivities: any[]) => ({
  ...TRIGGERED_ACTIVITY_CONFIG,
  filterVisibleConditionValues: (options: any[]) => visibleConditionsFilter(options, selectedActivities),
});
